import { useMemo } from 'react';
import { gql, useQuery } from '@apollo/client'

import { useSites } from 'store'
import { TimeRange } from 'models'

import { convertDateRange, getScale } from '../../hooks/use-traffic'
import { useGetStatsTimeRange } from '../../store'
import { filterStatsByTimeRange, generateRanges } from '../use-utils'

const OPERATION_TRAFFIC = gql`
  query TrafficGraphGroupByNetworkAndSsid($sfIds: [ID], $startsAt: String, $endsAt: String) {
    stats: trafficGraphGroupByNetworkAndSsid(sf_ids: $sfIds, starts_at: $startsAt, ends_at: $endsAt) {
      network_name
      requested_at
      download
      upload
      active_users
    }
  }
`

export const generateGraphNetworks = ({stats, ranges}) => {
  return ranges.map((range) => {
    const statsInRange = filterStatsByTimeRange(stats, range.from, range.to)
    const values = ['guest', 'private', 'other'].map(network => {
      const totalActiveUsers = statsInRange.reduce((acc, stat) => {
        return stat.network_name === network
          ? acc + stat.active_users
          : acc
      }, 0)
      const totalDownload = statsInRange.reduce((acc, stat) => {
        return stat.network_name === network
          ? acc + stat.download
          : acc
      }, 0)
      const totalUpload = statsInRange.reduce((acc, stat) => {
        return stat.network_name === network
          ? acc + stat.upload
          : acc
      }, 0)
      return {
        name: network,
        active_users: totalActiveUsers,
        upload: totalUpload,
        download: totalDownload,
      }
    })
    return {
      date: range.from,
      networks: values
    }
  })
}

const useGraph = ({modalTimeRange}) => {
  const [globalRange] = useGetStatsTimeRange()
  const [{ selected }] = useSites()
  const range = modalTimeRange || globalRange || TimeRange.LastTwelveMonths
  const scale = useMemo(() => {
    return getScale(range)
  }, [range])
  const dates = useMemo(() => {
    return convertDateRange(range)
  }, [range])

  const {loading, data} = useQuery(OPERATION_TRAFFIC, {
    variables: {
      sfIds: selected.map(({sf_id}) => sf_id),
      ...dates
    }
  })
  const formattedData = useMemo(() => {
    if (!data) {
      return []
    }
    return data.stats.map(stats => ({
      ...stats,
      download: parseInt(stats.download) / 1000,
      upload: parseInt(stats.upload) / 1000,
      active_users: parseInt(stats.active_users),
    }))
  }, [data])

  const graph = useMemo(() => {
    let ranges = generateRanges({...dates, scale})
    // le dernier jour / mois est supprimé
    if (getScale(range) !== 'year') {
      ranges = ranges.slice(0,-1)
    }
    const graph = generateGraphNetworks({stats: formattedData, ranges})
    return graph.map(stats => {
      const download = stats.networks.reduce((acc, network) => {
        return acc + network.upload + network.download
      }, 0)
      const activeUsers = stats.networks.reduce((acc, network) => {
        return acc + network.active_users
      }, 0)
      return {
        ...stats,
        average_per_device_type: activeUsers ? (download / activeUsers) : 0

      }
    })
  }, [formattedData])
  return {
    loading,
    graph
  }
}

export default useGraph

/*
1 182 914 341.8085938
90 000
 */
